import type { SearchResultJobV5 } from 'node_modules/@seek/chalice-types';

import type { JobDetails } from 'src/store/jobdetails/types';

import { AccessabilityLinks } from './AccessabilityLinks/AccessabilityLinks';
import JobDetail from './JobDetail/JobDetail';

export interface JobDetailViewProps {
  hideResults: boolean;
  currentJobDetails: JobDetails | null;
  isLoading: boolean;
  fetchJobDetails: () => void;
  selectedJob?: SearchResultJobV5;
}

export default ({
  hideResults,
  selectedJob,
  currentJobDetails,
  fetchJobDetails,
  isLoading,
}: JobDetailViewProps) => {
  if (hideResults) {
    return null;
  }

  return (
    <>
      <AccessabilityLinks placement="job-details" position="top" />
      <JobDetail
        currentJobDetails={selectedJob ? currentJobDetails : null}
        fetchJobDetails={fetchJobDetails}
        isLoading={isLoading}
      />
      {selectedJob ? (
        <AccessabilityLinks placement="job-details" position="bottom" />
      ) : null}
    </>
  );
};
